import { EssensysProductType } from '../Essensys';

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use EssensysProductInteractionType from application-types instead.
 */
export enum EssensysProductInteractionType {
  PointOfSale = 'Point of Sale',
  OnlinePlan = 'Online Plan',
}

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use EssensysProductFeatureProperties from application-types instead.
 */
export type EssensysProductFeatureProperties = {
  productInteractionType: EssensysProductInteractionType;

  // Point of Sale
  productId: string;
  syncPrice: boolean;
  syncName: boolean;
  ignorePublish: boolean;
  ignoreEndDate: boolean;
  productData: EssensysProductType;

  // Online Plan
};
